// src/registered/site-admin/components/SEC_03_UserRoleAssignmentController.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SEC_03_View from "./SEC_03_UserRoleAssignmentView.jsx"; 
import { GoldenSourceHelper } from "../../../app/Switch_Core_React_Standards";

export default function SEC_03_UserRoleAssignmentController() {
  const navigate = useNavigate();
  const [userList, setUserList] = useState([]);
  const [availableRoles, setAvailableRoles] = useState([]);
  const [availableResources, setAvailableResources] = useState([]);
  const [userMatrix, setUserMatrix] = useState([]);
  const [assignedResources, setAssignedResources] = useState([]); 
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedUser, setSelectedUser] = useState("");
  const [roleId, setRoleId] = useState("");
  const [resourceId, setResourceId] = useState("");

  const executeHandshake = async (slug, payload) => {
    const token = sessionStorage.getItem("SEC_SESSION_ID");
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/v1/${slug}`, {
      method: "POST",
      headers: { 
        "Content-Type": "application/json",
        "SITE-KEY": process.env.REACT_APP_SITE_KEY,
        "Authorization": `Bearer ${token}` 
      },
      body: JSON.stringify(payload || {})
    });
    const result = await response.json();
    return GoldenSourceHelper.normalize(result);
  };

  useEffect(() => {
    const loadMetadata = async () => {
      setIsSubmitting(true);
      const [u, r, res] = await Promise.all([
        executeHandshake("sustina/manage-users/search", { SearchTerm: "" }),
        executeHandshake("sustina/manage-users/roles", {}),
        executeHandshake("sustina/manage-users/resources", { ResourceType: "General" })
      ]);
      setUserList(u.data || []);
      setAvailableRoles(r.data || []);
      setAvailableResources(res.data || []);
      setIsSubmitting(false);
    };
    loadMetadata();
  }, []);

  const handleUserChange = async (e) => {
    const guid = e.target.value;
    setSelectedUser(guid);
    if (!guid) { setUserMatrix([]); return; }
    setIsSubmitting(true);
    const res = await executeHandshake("sustina/manage-users/matrix", { TargetUserGuid: guid });
    setUserMatrix(res.data || []);
    setIsSubmitting(false);
  };

  const handleAssign = async () => {
    if (!selectedUser || !roleId) return;
    setIsSubmitting(true);
    const res = await executeHandshake("sustina/manage-users/assign", {
      SiteUserGuid: selectedUser,
      RoleId: parseInt(roleId),
      ResourceId: resourceId || null,
      AdminGuid: sessionStorage.getItem("SEC_USER_GUID")
    });
    if (res.success) {
      const updated = await executeHandshake("sustina/manage-users/matrix", { TargetUserGuid: selectedUser });
      setUserMatrix(updated.data || []);
      setRoleId("");
      setResourceId("");
    }
    setIsSubmitting(false);
  };

  return (
    <SEC_03_View 
      userList={userList}
      availableRoles={availableRoles}
      availableResources={availableResources}
      userMatrix={userMatrix}
      assignedResources={assignedResources}
      selectedUser={selectedUser}
      roleId={roleId}
      resourceId={resourceId}
      isSubmitting={isSubmitting}
      onUserChange={handleUserChange}
      onRoleChange={(e) => setRoleId(e.target.value)}
      onResourceChange={(e) => setResourceId(e.target.value)}
      onAssign={handleAssign}
      onBack={() => navigate(-1)} // 🎯 Standard "Go Back" while retaining state
      onReturnToDashboard={() => navigate("/registered/dashboard")} 
    />
  );
}